import { render, staticRenderFns } from "./AudienceAnalysis.vue?vue&type=template&id=21b71bbc&scoped=true&"
import script from "./AudienceAnalysis.vue?vue&type=script&lang=js&"
export * from "./AudienceAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./AudienceAnalysis.vue?vue&type=style&index=0&id=21b71bbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b71bbc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/var/www/html/insights/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VFlex,VIcon,VLayout})
